/** Portuguese Workforce & Education Translations */
export const workforce = {
  workforce: {
    pageTitle: "Dimensão Força de Trabalho e Educação",
    weightInFII: "peso no FII",
    heroSubtitle: "Equipando jovens com habilidades para oportunidades econômicas (18-40 anos)",
    quote: "23% dos jovens trabalhadores estão subempregados em relação à sua educação, mas 85% dos empregos futuros exigem habilidades digitais. A lacuna entre educação e oportunidade não é escassez de aprendizes—é escassez de caminhos alinhados e acessíveis para empregos de qualidade.",
    fiiWeightDistribution: "Distribuição de peso do FII",
    mentalHealth: "Saúde Mental",
    workforceLabel: "Força de Trabalho",
    entrepreneurship: "Empreendedorismo",
    understandCrisis: "Entender a crise",
    crisisTitle: "A Crise da Força de Trabalho e Educação em Números",
    crisisSubtitle: "Estatísticas críticas que afetam a empregabilidade e educação dos jovens globalmente",
    crisis: {
      inThree: "em 3",
      stat1Label: "desemprego juvenil global (18-24 anos) vs. 5,8% adulto",
      stat2Label: "jovens NÃO em educação, emprego ou treinamento (NEET) globalmente",
      stat3Label: "trabalhadores subempregados em relação à educação",
      stat4Label: "empregos exigirão habilidades digitais até 2030",
      stat5Label: "matrícula média global no ensino superior (variação: 15%-78%)",
      stat6Label: "jovens na África Subsaariana fora da força de trabalho formal",
      stat7Label: "tempo médio diário em desenvolvimento de habilidades digitais",
      stat8Label: "maior desemprego em mercados emergentes vs. desenvolvidos",
    },
    severity: {
      crisis: "Crise",
      severe: "Severo",
      concerning: "Preocupante",
    },
    coreProblem: "O Problema Central",
    coreProblemDesc: "Diferente da saúde mental (que varia por bem-estar individual), as lacunas de força de trabalho e educação são impulsionadas por barreiras estruturais: acesso a treinamento de qualidade, disponibilidade de infraestrutura digital, alinhamento do mercado de trabalho com habilidades ensinadas e demanda dos empregadores por competências específicas. Estes são problemas solucionáveis se a JCI os abordar em escala.",
    fiiTitle: "Metodologia de Força de Trabalho do FII",
    fiiSubtitle: "Pontuação de Força de Trabalho = 30% do Índice de Impacto Futuro",
    subWeight: "sub-peso",
    globalAverage: "Média global",
    highest: "Mais alto",
    lowest: "Mais baixo",
    fii: {
      employmentRate: "Taxa de Emprego Juvenil",
      employmentRateDef: "Porcentagem de 18-40 anos em emprego formal (excluindo trabalho precário)",
      employmentHighest: "Países Nórdicos (85-90%)",
      employmentLowest: "África Subsaariana (45-55%)",
      skillsAlignment: "Alinhamento de Habilidades",
      skillsAlignmentDef: "Porcentagem de trabalhadores cujas habilidades correspondem aos requisitos do emprego",
      skillsHighest: "Suíça, Alemanha (70-75%)",
      skillsLowest: "Sul da Ásia (30-35%)",
      educationAccess: "Acesso à Educação",
      educationAccessDef: "Acesso combinado ao ensino superior e programas de treinamento vocacional",
      educationHighest: "Coreia do Sul, Finlândia (78%)",
      educationLowest: "Níger, Chade (15%)",
    },
    regionalTitle: "Pontuações Regionais de Força de Trabalho",
    regionalSubtitle: "Dimensão de Força de Trabalho do FII: Desempenho Regional",
    regions: {
      europe: "Europa",
      asiaPacific: "Ásia e o Pacífico",
      americas: "América",
      africaMe: "África e Oriente Médio",
    },
    status: {
      good: "Bom",
      moderate: "Moderado",
      atRisk: "Em Risco",
    },
    regional: {
      europeDrivers: "Sistemas de formação dual, educação vocacional forte",
      europeOpportunity: "Modelo para programas de treinamento JCI",
      asiaPacificDrivers: "Variação econômica: Japão/Coreia alto, Sul da Ásia baixo",
      asiaPacificOpportunity: "Alfabetização digital e parcerias de habilidades tecnológicas",
      americasDrivers: "América do Norte forte, América Latina tem lacunas",
      americasOpportunity: "Escalabilidade de programas JCI + CYE",
      africaMeDrivers: "População jovem, escassez de infraestrutura",
      africaMeOpportunity: "Maior impacto potencial—treinamento mobile-first",
    },
    employment: "Emprego",
    skillsLabel: "Habilidades",
    education: "Educação",
    projectionTitle: "Projeção 2024 vs 2040",
    skillsTitle: "Panorama Global de Habilidades",
    skillsSubtitle: "Análise da lacuna entre oferta e demanda de habilidades",
    hardSkills: "Habilidades Técnicas",
    softSkills: "Habilidades Comportamentais",
    supply: "Oferta",
    demand: "Demanda",
    skillNames: {
      dataAnalytics: "Análise de Dados",
      cloudComputing: "Computação em Nuvem",
      aiMl: "IA/Machine Learning",
      cybersecurity: "Cibersegurança",
      projectMgmt: "Gestão de Projetos",
      criticalThinking: "Pensamento Crítico",
      communication: "Comunicação",
      adaptability: "Adaptabilidade",
      leadership: "Liderança",
      creativity: "Criatividade",
    },
    deepDiveTitle: "Análises Regionais Detalhadas",
    deepDiveSubtitle: "Análise profunda de força de trabalho e educação por região JCI",
    strengths: "Pontos Fortes",
    challenges: "Desafios",
    jciOpportunity: "Oportunidade JCI",
    deepDive: {
      europe: {
        strength1: "Sistema de educação dual (Alemanha, Áustria, Suíça)",
        strength2: "Alto investimento em P&D e inovação",
        strength3: "Forte proteção trabalhista e benefícios",
        challenge1: "Envelhecimento da força de trabalho",
        challenge2: "Lacunas de habilidades digitais em algumas regiões",
        challenge3: "Desemprego juvenil no Sul da Europa",
        opportunity: "Exportar modelos de formação dual para outras regiões",
      },
      asiaPacific: {
        strength1: "Alta valorização cultural da educação",
        strength2: "Rápida adoção de tecnologia",
        strength3: "Força de trabalho jovem e crescente",
        challenge1: "Desigualdade de acesso entre países",
        challenge2: "Descompasso entre educação e mercado",
        challenge3: "Alta competição por empregos formais",
        opportunity: "Programas de habilidades digitais mobile-first",
      },
      americas: {
        strength1: "Ecossistema de inovação forte (EUA, Canadá)",
        strength2: "Espírito empreendedor crescente",
        strength3: "Diversidade de talentos",
        challenge1: "Desigualdade de acesso à educação de qualidade",
        challenge2: "Alto custo da educação superior",
        challenge3: "Subemprego de graduados",
        opportunity: "Escalar programas JIB + CYE na América Latina",
      },
      africaMe: {
        strength1: "População mais jovem do mundo",
        strength2: "Alta aspiração empreendedora",
        strength3: "Crescimento do ecossistema digital",
        challenge1: "Infraestrutura educacional limitada",
        challenge2: "Alto desemprego juvenil (14-16%)",
        challenge3: "Lacuna de financiamento crítica",
        opportunity: "Treinamento mobile-first e microfinanças para jovens",
      },
    },
    initiativesTitle: "Iniciativas Atuais da JCI",
    initiativesSubtitle: "Programas de força de trabalho e educação da JCI",
    program: "Programa",
    reach: "Alcance",
    target: "Público-Alvo",
    statusLabel: "Status",
    initiatives: {
      jibName: "JCI Jovens em Negócios (JIB)",
      jibTarget: "Jovens empreendedores (18-30)",
      jibDesc: "Treinamento de alfabetização empresarial e lançamento de startups",
      cyeName: "Empreendedorismo Juvenil Criativo (CYE)",
      cyeTarget: "Jovens criativos (16-25)",
      cyeDesc: "Programa de habilidades criativas e empreendedorismo",
      digitalName: "Academia Digital JCI",
      digitalTarget: "Todos os jovens (18-40)",
      digitalDesc: "Treinamento de habilidades digitais e alfabetização tecnológica",
      mentoringName: "Rede de Mentoria JCI",
      mentoringTarget: "Jovens profissionais (22-35)",
      mentoringDesc: "Conexão mentor-mentorado para desenvolvimento de carreira",
      riseName: "Projetos RISE",
      riseTarget: "Comunidades em risco",
      riseDesc: "Projetos de impacto comunitário focados em emprego",
      statusActive: "Ativo",
      statusGrowing: "Em Crescimento",
      statusExpanding: "Em Expansão",
    },
    outcomesTitle: "Resultados e Estudos de Caso",
    outcomesSubtitle: "Impacto mensurável dos programas de força de trabalho da JCI",
    cases: {
      paraguayCountry: "Paraguai",
      paraguayTitle: "JCI Asunción Digital Skills",
      paraguayOutcome: "Programa de treinamento digital para jovens desempregados resultou em alta taxa de empregabilidade",
      paraguayMetric: "taxa de empregabilidade",
      syriaCountry: "Síria (Refugiados)",
      syriaTitle: "JCI Refugee Skills Initiative",
      syriaOutcome: "Treinamento vocacional para jovens refugiados sírios em países vizinhos",
      syriaMetric: "jovens treinados",
      boliviaCountry: "Bolívia",
      boliviaTitle: "JCI Santa Cruz Empreende",
      boliviaOutcome: "Programa de microempreendedorismo para jovens de comunidades rurais",
      boliviaMetric: "empresas lançadas",
    },
    actionsTitle: "Ações Recomendadas para a JCI",
    actionsSubtitle: "Prioridades estratégicas para fechar a lacuna de força de trabalho",
    actions: {
      action1Title: "Escalar Academia Digital",
      action1Desc: "Expandir treinamento de habilidades digitais para todas as regiões, priorizando África/OM",
      action1Effort: "12-18 meses",
      action1Impact: "3x alcance",
      action2Title: "Parcerias Corporativas",
      action2Desc: "Desenvolver parcerias com empregadores para garantir caminhos de emprego",
      action2Effort: "6-12 meses",
      action2Impact: "Empregabilidade +40%",
      action3Title: "Educação Vocacional",
      action3Desc: "Criar programas de treinamento vocacional alinhados ao mercado",
      action3Effort: "18-24 meses",
      action3Impact: "Modelo sustentável",
      action4Title: "Mentoria em Escala",
      action4Desc: "Expandir rede de mentoria para 50.000+ conexões ativas",
      action4Effort: "24-36 meses",
      action4Impact: "Desenvolvimento de carreira",
      action5Title: "Certificações Reconhecidas",
      action5Desc: "Desenvolver certificações JCI reconhecidas por empregadores globais",
      action5Effort: "18-24 meses",
      action5Impact: "Credibilidade global",
      action6Title: "Fundo de Microfinanças",
      action6Desc: "Criar fundo de microfinanças para jovens empreendedores em mercados emergentes",
      action6Effort: "12-18 meses",
      action6Impact: "Acesso a capital",
    },
    ctaTitle: "Força de Trabalho é o Ativador",
    ctaDescription: "Força de trabalho e educação conectam saúde mental (fundação) ao empreendedorismo (acelerador). Jovens empregados têm melhor saúde mental, mais confiança e capacidade para iniciar negócios.",
    exploreFII: "Explorar FII",
    exploreMentalHealth: "Explorar Saúde Mental",
    dataSources: { title: "Fontes de Dados" },
  },
} as const;
